import clsx from "clsx";

const Button = ({
  children,
  type = "button",
  variant = "primary",
  size = "md",
  fullWidth = false,
  loading = false,
  disabled = false,
  leftIcon = null,
  rightIcon = null,
  className = "",
  ...props
}) => {
  const isDisabled = disabled || loading;

  const baseClasses =
    "inline-flex items-center justify-center gap-2 rounded-xl font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60";

  const variantClasses = {
    primary:
      "bg-[#8B3A3A] text-white hover:bg-[#a64545] focus:ring-[#8B3A3A]",
    secondary:
      "bg-white text-[#8B3A3A] border border-[#d7c2a3] hover:bg-[#faf6ef] focus:ring-[#8B3A3A]",
    outline:
      "bg-transparent text-[#8B3A3A] border border-[#8B3A3A] hover:bg-[#f9f1e7] focus:ring-[#8B3A3A]",
    ghost:
      "bg-transparent text-[#3b2f2f] hover:bg-[#f5efe6] focus:ring-[#8B3A3A]",
    danger:
      "bg-red-600 text-white hover:bg-red-700 focus:ring-red-600",
  };

  const sizeClasses = {
    sm: "px-3 py-2 text-sm",
    md: "px-4 py-2.5 text-sm",
    lg: "px-6 py-3 text-base",
  };

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={clsx(
        baseClasses,
        variantClasses[variant] || variantClasses.primary,
        sizeClasses[size] || sizeClasses.md,
        fullWidth && "w-full",
        className
      )}
      {...props}
    >
      {leftIcon && <span className="inline-flex">{leftIcon}</span>}
      <span>{loading ? "Just a moment..." : children}</span>
      {rightIcon && !loading && <span className="inline-flex">{rightIcon}</span>}
    </button>
  );
};

export default Button;